import "./style.css";

import Api from "@/components/Api";
import { tablet } from "../../app/breakpoints";

export default class ContactForm {
  static selector = ".contact-form";

  constructor(block) {
    this.block = block;

    this.vw = document.documentElement.clientWidth;

    this.fields = [
      ...this.block.querySelectorAll(
        ".contact-form__inputs-row__item__input__field"
      ),
    ];
    this.submitButton = this.block.querySelector(".contact-form__button");

    this.littleLabels = this.block.querySelectorAll(
      ".contact-form__inputs-row__item__little-label"
    );

    this.errorIcons = this.block.querySelectorAll(
      ".contact-form__inputs-row__item__input > *:last-child"
    );

    this.errorMessages = this.block.querySelectorAll(
      ".contact-form__inputs-row__item span"
    );

    this.textareaErrorIcon = this.block.querySelector(
      ".contact-form__textarea--title >*:last-child"
    );

    this.textareaLabel = this.block.querySelector(
      ".contact-form__textarea--title__label"
    );

    // this.checkBoxes = this.block.querySelectorAll("input[type='checkbox']");
    // this.checkBoxesLabels = this.block.querySelectorAll(
    //   ".contact-form__checkbox"
    // );

    this.init();
  }

  validateEmail = (email) => {
    var re = /^\w+(?:[.-]\w+)*@\w+(?:[.-]\w+)*(?:\.\w{2,3})+$/;
    return re.test(String(email).toLowerCase());
  };

  validateField = (element, index) => {
    if (element.required && !element.value) {
      if (element.id == "message") {
        this.textareaLabel.classList.add("error");
        this.textareaErrorIcon.classList.add("show");
      }
      element.classList.add("error");

      if (index < 4) {
        this.errorIcons[index].classList.add("show");
        this.errorMessages[index].classList.add("show");
      }

      this.hasErrors = true;
    } else {
      if (element.id == "message") {
        this.textareaLabel.classList.remove("error");
        this.textareaErrorIcon.classList.remove("show");
      }
      if (element.id == "email") {
        var isValid = this.validateEmail(element.value);
        if (!isValid) {
          element.classList.add("error");
          this.errorIcons[index].classList.add("show");
          this.errorMessages[index].classList.add("show");
          this.hasErrors = true;
        } else {
          element.classList.remove("error");
          this.errorIcons[index].classList.remove("show");
          this.errorMessages[index].classList.remove("show");
        }
      } else {
        element.classList.remove("error");
        if (index < 4) {
          this.errorIcons[index].classList.remove("show");
          this.errorMessages[index].classList.remove("show");
        }
      }
    }
  };

  sendData = async (data) => {
    try {
      await Api.postContactUs(data);
      this.submitButton.innerHTML = window.backendVars.copy["Message sent"];
      this.fields.forEach((f, i) => {
        f.value = "";
      });
    } catch (e) {
      this.handleError(e);
    }
  };

  handleError = (error) => {
    console.log("Error when attempting to send form: ", error);
  };

  submit = (e) => {
    e.preventDefault();
    this.hasErrors = false;
    this.fields.forEach((f, i) => {
      this.validateField(f, i);
    });
    // this.validateCheckboxes();
    if (!this.hasErrors) {
      const data = this.fields.reduce((acc, el) => {
        acc[el.name || el.id] = el.value;
        return acc;
      }, {});

      this.sendData(data);
    }
  };

  validateCheckboxes = () => {
    this.checkBoxes.forEach((item, index) => {
      if (!item.checked) {
        this.checkBoxesLabels[index].classList.add("error");
        this.hasErrors = true;
        return;
      } else {
        this.checkBoxesLabels[index].classList.remove("error");
      }
    });
  };

  init() {
    this.fields.forEach((field, i) => {
      field.addEventListener("blur", (e) => {
        this.validateField(e.target, i);
        this.littleLabels[i].style.display = "none";
      });

      field.addEventListener("focus", (e) => {
        this.littleLabels[i].style.display = "block";
      });
    });

    // this.checkBoxes.forEach((checkbox, index) => {
    //   checkbox.addEventListener("change", function () {
    //     if (this.checked) {
    //       var labels = document.querySelectorAll(".contact-form__checkbox");
    //       labels[index].classList.remove("error");
    //     }
    //   });
    // });

    this.submitButton.addEventListener("click", this.submit);
  }
}
